<script>
import { mapState, mapActions } from 'vuex';

export default {
    computed: {
        ...mapState(['showSearchOverlay']),
    },
    methods: {
        ...mapActions(['toggleSearchOverlay']),
    },
    watch: {
        'showSearchOverlay': (val) => {
           if (val) {
               document.getElementById('overlaySearch').focus();
           }
        }
    }
};
</script>
